export const formIsValid = e => {  
  e.target.classList.add('was-validated');
  e.preventDefault();
  e.stopPropagation();
  return e.target.checkValidity();
}